import { Button } from '@amzn/awsui-components-react';
import { get } from 'lodash';
import React from 'react';
import { generatePath, useHistory } from 'react-router';
import { TableComponent } from '../../../Components/Common/TableComponent';
import { TimezoneToggle } from '../../../Components/TimezoneToggle';
import CopyText from '../../../utils/copy-text';
import { JUNO_COLLECTION_GROUP_PATH } from "../../commons/constants";

const CollectionGroupList = (props) => {

    const history = useHistory();
    const collectionGroupsListVisibleContent = [
        'id',
        'name',
        'created_date',
        'number_of_collections',
        'standby_replicas',
        'generation',
        'placement_constraint_id'
    ];

    const COLLECTION_GROUPS_LIST_VISIBLE_CONTENT_OPTIONS = [
        {
            label: 'Options',
            options: collectionGroupsListVisibleContent.map((c) => {
                return { id: c, label: c };
            }),
        },
    ];

    const COLLECTION_GROUPS_LIST_FILTERING_PROPERTIES: any =
        collectionGroupsListVisibleContent.map((c) => {
            return {
                propertyLabel: c,
                key: c,
                groupValuesLabel: `${c} Values`,
                operators:
                    c === 'CollectionCreatedAt'
                        ? [':', '!:', '=', '!=', '>', '>=', '<', '<=']
                        : [':', '!:', '=', '!='],
            };
        });

    const COLLECTION_GROUPS_LIST_DEFAULT_PREFERENCES = {
        pageSize: 10,
        visibleContent: collectionGroupsListVisibleContent,
        wraplines: false,
    };

    const collectionGroupsListColumnDefinitions = [
        {
            id: 'id',
            header: 'Collection Group Id',
            cell: (e) => (
                <React.Fragment>
                    <CopyText
                        copyText={e.id}
                        copyButtonLabel={e.id}
                        successText="Collection Group Id copied"
                        errorText="Collection Group Id copied"
                    />
                    <Button
                        href={generatePath(JUNO_COLLECTION_GROUP_PATH, {awsAccountId: props.awsAccountId, collectionGroupId: e.id})}
                        variant="link"
                        onFollow={(event) => {
                            event.preventDefault();
                            history.push({
                                pathname: generatePath(JUNO_COLLECTION_GROUP_PATH, {awsAccountId: props.awsAccountId, collectionGroupId: e.id}),
                                state: {
                                    collectionGroupDetails: e
                                },
                            });
                        }}
                    >
                        <span style={{ color: '#00a1c9' }}>{e['id'] ? e['id'] : ''}</span>
                    </Button>
                </React.Fragment>
            ),
            sortingField: 'id',
        },
        {
            id: 'name',
            header: 'Collection Group Name',
            cell: (e) =>
                e['name'] ? (
                    <CopyText
                        copyText={e.name}
                        copyButtonLabel={e['name']}
                        successText="Collection Group Name copied"
                        errorText="Collection Group Name copied"
                    />
                ) : (
                    ''
                ),
            sortingField: 'name',
        },
        {
            id: 'placement_constraint_id',
            header: 'Placement Constraint Id',
            cell: (e) =>
                e['placement_constraint_id'] ? (
                    <CopyText
                        copyText={e['placement_constraint_id']}
                        copyButtonLabel={e['placement_constraint_id']}
                        successText="Placement Constraint Id copied"
                        errorText="Placement Constraint Id copied"
                    />
                ) : (
                    '--'
                ),
            sortingField: 'placement_constraint_id',
        },
        {
            id: 'standby_replicas',
            header: 'Standby Replicas',
            cell: (e) =>
                e['standby_replicas'] ? (
                    e['standby_replicas']
                ) : (
                    '--'
                ),
            sortingField: 'name',
        },
        {
            id: 'generation',
            header: 'Generation',
            cell: (e) => e['generation'] ?? '--',
            sortingField: 'generation',
        },
        {
            id: 'created_date',
            header: 'Created Date',
            cell: (e) =>
                e['created_date'] ? (
                    <TimezoneToggle date={new Date(e.created_date)} />
                ) : (
                    ''
                ),
            sortingField: 'created_date',
        },
        {
            id: 'number_of_collections',
            header: 'Number of Collections',
            cell: (e) => (e['number_of_collections'] ? e['number_of_collections'] : '-'),
            sortingField: 'number_of_collections',
        }
    ];
    return (
        <TableComponent
            tableDefaultPreferences={COLLECTION_GROUPS_LIST_DEFAULT_PREFERENCES}
            dataLoading={props.collectionGroupsListLoading}
            data={get(props.collectionGroupsList, 'listCollectionGroups', [])}
            filteringProperties={COLLECTION_GROUPS_LIST_FILTERING_PROPERTIES}
            csvExportFileName={'collectionGroupsList.csv'}
            columnDefinitions={collectionGroupsListColumnDefinitions}
            visibleContentOptions={COLLECTION_GROUPS_LIST_VISIBLE_CONTENT_OPTIONS}
            tableHeaderName={'Collection Groups'}
        />
    )
};

export { CollectionGroupList }
